<template>
	<div class="container">
		<div class="upper">
			<p><b>Vielen Dank für Ihre Teilnahme!</b></p>
			<img class="smile" src="@/assets/img/smile.png" />
		</div>
		<div class="lower">
			<p>
				Ihre Daten wurden erfolgreich gespeichert.<br />
				Sie können das Browserfenster nun schließen.
			</p>
		</div>
		<img class="logo" src="@/assets/img/qualis_logo.png" />
	</div>
</template>

<script>
export default {};
</script>

<style scoped>
.container {
	width: 100%;
	text-align: center;
}

.upper {
	background-color: rgb(140, 188, 107);
	color: white;
	font-size: 2rem;
	width: 100%;
	text-align: center;
	padding: 0.5rem 0;
}

.upper > * {
	margin: 0.5rem 0;
}

.lower {
	width: 100%;
	background-color: rgb(217, 217, 217);
	text-align: center;
	color: black;
	padding: 1rem 0;
}

.logo {
	max-width: 50vmin;
}
</style>
